export const DEFAULT_X_AXIS_KEY = 'DEFAULT_X_AXIS_KEY';
export const DEFAULT_Y_AXIS_KEY = 'DEFAULT_Y_AXIS_KEY';
export const DEFAULT_ROTATION_AXIS_KEY = 'DEFAULT_ROTATION_AXIS_KEY';
export const DEFAULT_RADIUS_AXIS_KEY = 'DEFAULT_RADIUS_AXIS_KEY';
export const DEFAULT_MARGINS = {
  top: 20,
  bottom: 20,
  left: 20,
  right: 20,
};
export const DEFAULT_AXIS_SIZE_WIDTH = 45;
export const DEFAULT_AXIS_SIZE_HEIGHT = 25;

// How many pixels to add to the default axis size if that axis has a label
export const AXIS_LABEL_DEFAULT_HEIGHT = 20;
